'use strict';

const LOCAL_TZ = 'America/Los_Angeles';

function formatLastVisit(iso, tz = LOCAL_TZ) {
  const d = new Date(iso);
  if (!Number.isFinite(d.getTime())) return '';
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: tz,
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  }).formatToParts(d);
  const get = (type) => parts.find((p) => p.type === type)?.value || '';
  return `${get('month')} ${get('day')}, ${get('hour')}:${get('minute')} ${get('dayPeriod')}`;
}

function whatChangedEmptyLine(iso, tz = LOCAL_TZ) {
  return `No changes since your last visit on ${formatLastVisit(iso, tz)}.`;
}

function last14DaysIso(now = new Date()) {
  return new Date(now.getTime() - 14 * 24 * 60 * 60 * 1000).toISOString();
}

function stripChangedParam(search) {
  const n = search instanceof URLSearchParams ? new URLSearchParams(search) : new URLSearchParams(String(search || ''));
  n.delete('changed');
  if (n.get('tab') === 'timeline') n.set('tab', 'pulse');
  return n;
}

export { formatLastVisit, whatChangedEmptyLine, last14DaysIso, stripChangedParam };
